import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ce-service-tools-certification-dialog',
    templateUrl: './service-tools-certification-dialog.component.html',
    styleUrls: ['./service-tools-certification-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ServiceToolsCertificationDialogComponent {
    static open(matDialog: MatDialog): MatDialogRef<ServiceToolsCertificationDialogComponent> {
        return matDialog.open(ServiceToolsCertificationDialogComponent, {
            panelClass: 'ce-mdc-dialog',
            width: '780px',
            maxHeight: '90vh',
            autoFocus: 'first-heading',
            delayFocusTrap: false,
        });
    }

    constructor(private readonly dialogRef: MatDialogRef<ServiceToolsCertificationDialogComponent>) {}

    close(): void {
        this.dialogRef.close();
    }
}
